import React from "react";
import { useTranslation } from "react-i18next";
import SelectInsideReactHookForm from "components/bootstrap/SelectInsideReactHookForm";
import {
  TheDriverCommitedOnEnum,
  whatIsReportProblematic,
  UserRole,
  ReportRejectionReasonType,
  DecisionTypesCode,
} from "components/Reports/reportAssets/assets";
import { useReports } from "hooks/useReports";
import { useRole } from "hooks/useRole";
import CustomTextArea from "components/Form/TeaxtAreaBootstrap";
import { optionsSelectInFormHandler } from "components/MultiSelect/multiSelect.types";
import { useGetRejectionReasonsListQuery } from "features/api/contentManagement/contentManagementApiSlice";
import { DBSeriousOffenseReason } from "models/RejectionReason";

type DropDownsLogicProps = { control; errors; setValue; getValues };

const RenderDropDownsLogic = ({
  control,
  errors,
  getValues,
}: DropDownsLogicProps) => {
  const { t } = useTranslation();
  const {
    seriousOffenseReasonsType,
  }: {
    seriousOffenseReasonsType: DBSeriousOffenseReason[];
  } = useReports();

  const { data: rejectionReasons = [] } = useGetRejectionReasonsListQuery();

  const role = useRole();

  const decisionCurrnetValue = getValues("decisionTypeID");
  const rejectionReasonsCurrnetValue = getValues("rejectionReasonID");
  const other = rejectionReasons.find(
    (reason) => reason.id === ReportRejectionReasonType.other
  );
  const rejectionReasonOptions = rejectionReasons
    .filter((reason) => reason.id !== ReportRejectionReasonType.other)
    .map((reason) => ({
      label: reason.name,
      value: reason.id,
      isDisabled: reason.disable,
    }))
    .concat({
      label: other?.name,
      value: ReportRejectionReasonType.other,
    });

  const renderDropDowns = () => {
    if (decisionCurrnetValue === DecisionTypesCode.DisqualificationReport) {
      return (
        <>
          <SelectInsideReactHookForm
            name="rejectionReasonID"
            control={control}
            rules={{
              required: {
                value: true,
                message: t("validationRequired"),
              },
            }}
            options={rejectionReasonOptions}
            label={t("rejectionReasons")}
            error={errors.rejectionReasonID?.message}
            isFloatingLabel={false}
            isRowNeeded={false}
            className="displayBlock"
          />

          {Number(rejectionReasonsCurrnetValue) ===
            ReportRejectionReasonType.inappropriateBehavior && (
            <>
              <SelectInsideReactHookForm
                name="driverOffenceTypeCode"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("validationRequired"),
                  },
                }}
                defaultValue=""
                options={optionsSelectInFormHandler(TheDriverCommitedOnEnum)}
                label={t("theDriverCommitted")}
                error={errors.driverOffenceTypeCode?.message}
                isFloatingLabel={false}
              />
              <SelectInsideReactHookForm
                name="problemReportTypeCode"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("validationRequired"),
                  },
                }}
                defaultValue=""
                options={optionsSelectInFormHandler(whatIsReportProblematic)}
                label={t("WhatIsReportProblematic")}
                error={errors.problemReportTypeCode?.message}
                isFloatingLabel={false}
              />
            </>
          )}
        </>
      );
    }
    if (decisionCurrnetValue === DecisionTypesCode.SevereInformationLetter) {
      return (
        <SelectInsideReactHookForm
          isFloatingLabel={false}
          name="whyOffenseSeriousCode"
          control={control}
          rules={{
            required: {
              value: true,
              message: t("validationRequired"),
            },
          }}
          defaultValue=""
          options={
            seriousOffenseReasonsType
              ? seriousOffenseReasonsType?.map(
                  (option: DBSeriousOffenseReason) => ({
                    label: option.name,
                    value: option.id,
                    isDisabled: option.disable,
                  })
                )
              : []
          }
          label={t("whyOffenseSerious")}
          error={errors.whyOffenseSeriousCode?.message}
        />
      );
    }
    if (
      (role === UserRole.SENIOR || role === UserRole.CONTROLCENTER) &&
      decisionCurrnetValue === DecisionTypesCode.PackingForPolice
    ) {
      return (
        <CustomTextArea
          name="commentToPolice"
          control={control}
          label={t("commentToPolice")}
          rows={4}
          errors={errors.commentToPolice}
          required
          maxLength={240}
        />
      );
    }
    return null;
  };

  return renderDropDowns();
};

export default RenderDropDownsLogic;
